import dayjs, { Dayjs } from 'dayjs';

export const format = (value: ParsableDate | Dayjs | null, pattern: string): string => {
  if (!value) return '';

  const date = dayjs.isDayjs(value) ? value : dayjs(value);

  return date.format(pattern);
};
